// extracted by mini-css-extract-plugin
export var bodyRow = "_d7-d";
export var cardColumns = "_d7-e";
export var ellipsesOverflow = "_d7-2";
export var flatBottomCorners = "_d7-3";
export var flatTopCorners = "_d7-4";
export var headerActionsDropdown = "_d7-f";
export var headerBottomRow = "_d7-c";
export var headerTopRow = "_d7-b";
export var orderDetailsWrapper = "_d7-0";
export var orderInfoContainer = "_d7-1";
export var productDetails = "_d7-9";
export var productImage = "_d7-5";
export var responsiveTable = "_d7-8";
export var shipmentContainer = "_d7-a";
export var tableBottomLeft = "_d7-6";
export var tableBottomRight = "_d7-7";
export var trackingLink = "_d7-g";